import axios, { AxiosInstance } from "axios";
import { AxiosRequestConfig } from "axios";
import Message from "../utility/notifications/Message";

//https://laravel-news.com/building-flexible-axios-clients

// const user = useAuthentication();

/**
 * Create a new Axios client instance
 * @see https://github.com/mzabriskie/axios#creating-an-instance
 */
const getClient = async (baseUrl = process.env.REACT_APP_API_BASE_URL) => {
  const options = {
    baseURL: baseUrl,
  } as AxiosRequestConfig;

  //   if (accessToken) {
  //     options.headers = {
  //       Authorization: `Bearer ${accessToken}`,
  //     };
  //   }

  options.headers = {
    ...options.headers,
    "Content-Type": "application/json",
  };

  const client = axios.create(options);

  // Add a request interceptor
  client.interceptors.request.use(
    (requestConfig) => requestConfig,
    (requestError) => {
      return Promise.reject(requestError);
    }
  );
  // Add a response interceptor
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.status >= 500) {
        Message("Oeps", error.response.data.exception, "error");
      } else {
        Message("Oeps", error.response.data.exception, "error");
      }

      return Promise.reject(error);
    }
  );
  return client;
};

class ApiClient {
  client: AxiosInstance;

  constructor() {
    getClient().then((result) => {
      this.client = result;
    });
  }
  get(url: string, conf = {}) {
    return this.client
      .get(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  delete(url: string, conf = {}) {
    return this.client
      .delete(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  head(url: string, conf = {}) {
    return this.client
      .head(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  options(url: string, conf = {}) {
    return this.client
      .options(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  post(url: string, data = {}, conf = {}) {
    return this.client
      .post(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  put(url: string, data = {}, conf = {}) {
    return this.client
      .put(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  patch(url: string, data = {}, conf = {}) {
    return this.client
      .patch(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
}
export { ApiClient };
